const theme = {
	colors: {
		main: '#fffaed',
		dark: '#2c2623',
		first: '#679f92',
		second: '#831966',
		third: '#dddddd',
		fourth: '#19835d',
		fifth: '#7eb3a7',
		text: {
			light: '#fffaed',
			normal: '#72625a',
			dark: '#2c2623',
			darker: '#111111'
		},
		days: {
			v: {
				line_1a: '#83a5b3',
				line_1b: '#a8cedd',
				line_2a: '#89b9ae',
				line_2b: '#a8ddd1',
				line_3a: '#a3b788',
				line_3b: '#c6dda8'
			},
			b: {
				line_1a: '#c3936f',
				line_1b: '#e9b188',
				line_2a: '#c57070',
				line_2b: '#e98888',
				line_3a: '#837ea3',
				line_3b: '#aba5cd'
			}
		}
	}
}
export default theme